import React from 'react'
import { Text } from 'blaze-ui/Text/Text'
import Styles from './NoDocumentsState.module.scss'
import { Upload } from 'blaze-ui/icons'
import { Button } from 'blaze-ui/Button'

interface EmptyStateProps {
  onUploadClick: () => void
}

export const NoDocumentsState: React.FC<EmptyStateProps> = ({ onUploadClick }) => {
  return (
    <div className={Styles.container}>
      <div className={Styles.content}>
        <Text variant="largeList">No documents found</Text>
        <Text>You don't have any documents yet. Would you like to upload a PDF instead?</Text>
      </div>
      <div className={Styles.uploadPdfContainer}>
        <Button variant="tertiary" frontIcon={Upload} onPress={onUploadClick} size="sm">
          Upload PDF
        </Button>
        <Text variant="secondary" color="var(--dark-40)">
          Blaze supports PDF files up to 10MB
        </Text>
      </div>
    </div>
  )
}

export default NoDocumentsState
